import { CloudDownloadOutlined, DeleteFilled } from "@ant-design/icons";
import { Button, Card, Popconfirm } from "antd";
import { clsx } from "clsx";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { downloadAttachment, getImageByUrl } from "../../Common";
import { ReactComponent as FolderIcon } from "../../assets/svg/folderIcon2.svg";
import { deleteFile, getDirectory, getFiles } from "../../redux/action/file";
import {
  downloadAndDecryptFile,
  formatDateToYYYYMMDD,
  formatFileSize,
} from "../../utils/common";
import { useSelector } from "react-redux";
import { debugLog } from "../../utils/debugLog";
import { useTranslation } from "react-i18next";
import DeleteFilesDialog from "../DeleteFilesDialog";
import UploadProgressModal from "../DownloadModal";
import { Spin } from "antd";
const FileCard = ({
  name,
  isSub = false,
  icon = true,
  isNav = false,
  directory,
  thumbnailUrl,
  isHeader = false,
  actualImage,
  ext,
  fileId,
  itemCount, // Add this prop for folder item count
  fileSize, // Add this prop for folder size
  fileDate,
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  console.log("🚀 ~ isNav:", isNav);
  const { encryptionKeys } = useSelector((state) => state.authSlice);
  const { Date, ivKey, spaceKey } = encryptionKeys ?? {};
  const key = spaceKey;
  const iv = ivKey;
  const navigate = useNavigate();
  const location = useLocation();
  const [thumbnail, setThumbnail] = useState("");
  const [progress, setProgress] = useState();
  const [totalSize, setTotalSize] = useState();
  const [downloadedSize, setDownloadedSize] = useState();

  const handleClick = async (name) => {
    if (isNav === "folder") {
      const fileName = name?.toLowerCase();
      await getDirectory(fileName);
      navigate(`/cloud/${fileName}`);
    } else if (isNav === "file") {
      const path = location.pathname.split("/").pop();
      localStorage.setItem(
        "fileDirectory",
        JSON.stringify({ path, directory })
      );
      getFiles(path, directory);
      navigate("/cloud/files");
    }
  };

  const cardStyle = {
    background: "$primary-color",
  };
  debugLog("🚀 ~ thumbnail:", "log", thumbnailUrl);

  useEffect(() => {
    const getThumb = async () => {
      const res = await getImageByUrl(thumbnailUrl);
      setThumbnail(res);
    };
    if (isSub) getThumb();
  }, []);

  const handleDownloadAttachment = async (e) => {
    e.stopPropagation();
    const res = await getImageByUrl(actualImage);
    if (res) downloadAttachment(res, name, ext);
  };

  const handleDeleteFile = async (e, fileId) => {
    e.stopPropagation();
    const { path, directory } = JSON.parse(
      localStorage.getItem("fileDirectory")
    );
    const body = [`${fileId}`];
    await deleteFile(body);
    await getFiles(path, directory);
  };

  // Determine card class based on isNav
  const cardClassName = clsx("file-card", {
    "folder-card": isNav === "folder",
    "file-gallery-card": isNav === "file", // New class for file cards
    [name]: true,
  });
  const { t } = useTranslation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    // Create a mock event object or modify the call
    const mockEvent = {
      stopPropagation: () => {},
      preventDefault: () => {},
    };

    // Call your existing delete handler with mock event
    handleDeleteFile(mockEvent, fileId);
    setShowDeleteModal(false);
  };

  // Alternative approach - if you can modify handleDeleteFile
  const handleConfirmDeleteAlternative = () => {
    try {
      // Check if handleDeleteFile expects event object
      handleDeleteFile(null, fileId);
    } catch (error) {
      // If error, call with mock event
      const mockEvent = {
        stopPropagation: () => {},
        preventDefault: () => {},
      };
      handleDeleteFile(mockEvent, fileId);
    }
    setShowDeleteModal(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };
  return (
    <div className={cardClassName}>
      <Card
        bordered={false}
        onClick={() => handleClick(name)}
        style={isSub && isNav !== "folder" ? cardStyle : null}
        className="card-container"
        bodyStyle={isNav ? {} : { padding: 0 }}
      >
        <div>
          {isNav === "folder" ? (
            // Folder card content
            <>
              <div className="folder-icon">
                <FolderIcon />
              </div>
              <div className="folder-name" title={name}>
                {t(`label.${name.toLowerCase()}`)}
              </div>
              <div className="folder-details">
                <span className="item-count">{itemCount || 2} items</span>
                <span className="file-size">{fileSize || "10 MB"}</span>
              </div>
              <div className="folder-arrow">»</div>
            </>
          ) : isNav === "file" ? (
            // File gallery card content
            <>
              <div className="file-thumbnail" style={{ position: "relative" }}>
                {!isImageLoaded && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 10,
                    }}
                  >
                    <Spin size="large" />
                  </div>
                )}

                {thumbnail && (
                  <img
                    src={thumbnail}
                    alt={name}
                    className="thumbnail-image"
                    onLoad={() => setIsImageLoaded(true)}
                    onError={() => setIsImageLoaded(true)} // in case image fails to load
                    style={!isImageLoaded ? { visibility: "hidden" } : {}}
                  />
                )}
              </div>

              <div className="file-overlay">
                <div
                  title={name}
                  className={clsx("file-name ellipse", {
                    "sub-file-name": isSub,
                  })}
                >
                  {name}
                </div>
              </div>

              {/* Count badge outside card */}
              {/* <div className="file-count-badge">{fileSize || "06"}</div> */}
            </>
          ) : (
            // Default file card content
            <>
              {/* Top Half - Thumbnail */}
              <div className="file-thumbnail" style={{ height: 154 }}>
                {thumbnail ? (
                  <img
                    src={thumbnail}
                    alt={name}
                    width={140}
                    height={154}
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      borderTopLeftRadius: "19px",
                      borderTopRightRadius: "19px",
                    }}
                  />
                ) : (
                  <img
                    src={""}
                    alt="No preview"
                    style={{
                      height: "60px",
                      opacity: 0.3,
                    }}
                  />
                )}
              </div>

              <div className="file-info-panel">
                <div className="file-name" title={name}>
                  {name}
                </div>
                <div className="file-meta">
                  {formatFileSize(fileSize) || "-"}
                </div>
                <div className="file-date">
                  {formatDateToYYYYMMDD(fileDate) || "-"}
                </div>
                <div className="file-actions">
                  <Button
                    size="small"
                    type="primary"
                    className="custom-download-btn responsive-btn"
                    style={{
                      fontSize: "clamp(10px, 2.5vw, 14px)",
                      padding: "4px 8px",
                      minWidth: "70px",
                      height: "auto",
                    }}
                    onClick={(e) =>
                      downloadAndDecryptFile(actualImage, name, ext, iv, key, {
                        setProgress,
                        setTotalSize,
                        setDownloadedSize,
                        setShowDownloadModal,
                      })
                    }
                  >
                    {t("common.download")}
                  </Button>

                  <Button
                    size="small"
                    danger
                    type="primary"
                    className="responsive-btn restore-btn"
                    onClick={handleDeleteClick}
                    style={{
                      borderRadius: 30,
                      fontSize: "clamp(10px, 2.5vw, 14px)",
                      padding: "4px 8px",
                      minWidth: "70px",
                      height: "auto",
                    }}
                  >
                    {t("common.delete")}
                  </Button>
                </div>
              </div>

              <DeleteFilesDialog
                visible={showDeleteModal}
                onDelete={handleConfirmDelete}
                onCancel={handleCancelDelete}
              />
              <UploadProgressModal
                onCancel={() => setShowDownloadModal(false)}
                visible={showDownloadModal}
                progress={progress}
                totalSize={totalSize}
                downloadedSize={downloadedSize}
              />
            </>
          )}
        </div>
      </Card>
    </div>
  );
};

export default FileCard;
